















































import { Component, Mixins } from 'vue-property-decorator'

import { mdiLogout, mdiPhoneOutline } from '@mdi/js'

import { security } from '@/store/modules/security'
import { notifications } from '@/store/modules/notifications'
import { settings } from '@/store/modules/settings'
import { support } from '@/store/modules/support'
import { Navigator } from '@/mixins/Navigator'

import NotificationBar from '@/components/layouts/app/NotificationBar.vue'
import { mock } from '@/tools'

@Component({
  components: {
    NotificationBar,
  },
})
class DefaultTemplate extends Mixins<Navigator>(Navigator) {
  securityModule = security.context(this.$store)
  notificationsModule = notifications.context(this.$store)
  settingsModule = settings.context(this.$store)
  supportModule = support.context(this.$store)

  icons = {
    mdiLogout,
    mdiPhoneOutline,
  }
  htmlTag = document.documentElement

  get phone() {
    return this.supportModule.state.phone
  }

  get portalLink() {
    return process.env.VUE_APP_PORTAL_LINK
  }

  async logout() {
    try {
      await this.$router.push({ name: 'logout' })
    } catch (error) {
      mock(error)
    }
  }
}

export default DefaultTemplate
